<template>
    <div class="float-left">
        <b-button
            variant="success"
            @click="abrirModal()"
            >Adicionar
        </b-button>
        <prestacao-contas-final-lancamento-form
            operacaoProp="I"
            :convenio = "convenio"
            :prestacaoContasFinalLancamento="prestacaoContasFinalLancamento"
            :prestacaoMensal="prestacaoMensal"
            :mostrarModal="mostrarModal"
            :inseridoAtualizado="inseridoAtualizado"
            :erros="erros"
            @fechar="fecharModal()"
            @salvar="salvar($event)"
        ></prestacao-contas-final-lancamento-form>
    </div>
</template>

<script>
import ConveniosServicos from '../../ConveniosServicos'
import PrestacaoContasFinalLancamentoForm from './PrestacaoContasFinalLancamentoForm'

export default {
    components: {
        PrestacaoContasFinalLancamentoForm,
    },

    props: {
        convenio: Object,
        prestacaoMensal : Number,
        desativarBotao: Boolean
    },

    data() {
        return {
            mostrarModal: false,
            inseridoAtualizado: false,
            valor: 0,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false,
            },
            erros: [],
            naturezas: [],
            acoes: [],

            prestacaoContasFinalLancamento: {
                codSituacao: 1,
                codTipoPrestacaoContas: 0,
                dtEmissao: null,
                dtPagamento: null,
                idAcaoConvenio: 0,
                idNaturezaDespesa: 0,
                idPrestacaoContasFinal: 0,
                idPrestacaoContasMensal: 0,
                nuConfins: 0,
                nuCsll: 0,
                nuInss: 0,
                nuIr: 0,
                nuIss: 0,
                nuPis: 0,
                nuValor: 0,
                situacao: null,
                tipoPrestacaoContas: null,
                vcDoctoPag: null,
                vcDocumento: null,
                vcFavorecido: null,
                vcObservacao: null,
                simplesNacional: true,
                lancamentoBancario: null,
            },
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
            this.erros = [];
        },
        
        salvar(prestacaoContasFinalLancamento) {
            this.$store.dispatch('addRequest')
            let prestacaoFinal = {
                codSituacao: prestacaoContasFinalLancamento.codSituacao,
                codTipoPrestacaoContas: prestacaoContasFinalLancamento.codTipoPrestacaoContas,
                dtEmissao: this.$moment(this.prestacaoContasFinalLancamento.dtEmissao,'DD/MM/YYYY').format('YYYY-MM-DD'),
                dtPagamento: this.prestacaoContasFinalLancamento.dtPagamento != null ? this.$moment(this.prestacaoContasFinalLancamento.dtPagamento, 'DD/MM/YYYY').format('YYYY-MM-DD') : null,
                idAcaoConvenio: prestacaoContasFinalLancamento.idAcaoConvenio,
                idNaturezaDespesa: prestacaoContasFinalLancamento.idNaturezaDespesa,
                idPrestacaoContasFinal: prestacaoContasFinalLancamento.idPrestacaoContasFinal,
                idPrestacaoContasMensal: this.prestacaoMensal,
                nuConfins: prestacaoContasFinalLancamento.nuConfins,
                nuCsll: prestacaoContasFinalLancamento.nuCsll,
                nuInss: prestacaoContasFinalLancamento.nuInss,
                nuIr: prestacaoContasFinalLancamento.nuIr,
                nuIss: prestacaoContasFinalLancamento.nuIss,
                nuPis: prestacaoContasFinalLancamento.nuPis,
                nuValor: prestacaoContasFinalLancamento.nuValor,
                situacao: prestacaoContasFinalLancamento.situacao,
                tipoPrestacaoContas: prestacaoContasFinalLancamento.tipoPrestacaoContas,
                vcDoctoPag: prestacaoContasFinalLancamento.vcDoctoPag,
                vcDocumento: prestacaoContasFinalLancamento.vcDocumento,
                vcFavorecido: prestacaoContasFinalLancamento.vcFavorecido,
                simplesNacional: prestacaoContasFinalLancamento.simplesNacional,
                lancamentoBancario: prestacaoContasFinalLancamento.lancamentoBancario,
            }
            ConveniosServicos.inserirPrestacaoContasFinal(prestacaoFinal)
            .then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success('Lançamento Realizado com sucesso','OK', this.$toastConfig.success)
                        if(response.data.valorUltrapassadoDoPrevisto != null){
                            this.$toast.warning(`O valor do lançamento ultrapassa o valor previsto em ${response.data.valorUltrapassadoDoPrevisto}. Verifique a necessidade do reajuste.`,'Atenção', this.$toastConfig.warning)
                        }
                        this.$emit('atualizarLista')
                        this.$emit('ocorreuAlteracao')
                        this.inseridoAtualizado = !this.inseridoAtualizado;
                        this.erros = [];
                        this.fecharModal();
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },
    }
}
</script>

